import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import McmvRegistrationForm from '../McmvCad';
import Sidebar from '../Layout/Sidebar';
import api from '../../services/api';
import './Dashboard.css';

interface McmvRegistration {
  id: number;
  numero_inscricao: string;
  nome_completo: string;
  status: string;
  created_at: string;
  updated_at: string;
}

const UserDashboard: React.FC = () => {
  const { user, logout, registrationData } = useAuth();
  const [activeSection, setActiveSection] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [registration, setRegistration] = useState<McmvRegistration | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  // Carregar dados da pré-inscrição MCMV
  useEffect(() => {
    const loadRegistration = async () => {
      try {
        const response = await api.get('/mcmv/pre-registration');
        if (response.data.data) {
          setRegistration(response.data.data);
        }
      } catch (error) {
        console.log('Nenhum cadastro encontrado ou erro ao carregar');
      } finally {
        setIsLoading(false);
      }
    };

    loadRegistration();
  }, []);

  // Redirecionar automaticamente para a Ficha MCMV após criar a conta
  useEffect(() => {
    if (registrationData) {
      setActiveSection('cadastro');
    }
  }, [registrationData]);

  const renderContent = () => {
    switch (activeSection) {
      case 'dashboard':
        return (
          <div className="dashboard-section">
            <h1>Dashboard</h1>
            {isLoading ? (
              <div className="loading-message">
                <p>Carregando informações...</p>
              </div>
            ) : (
              <div className="dashboard-cards">
                <div className="dashboard-card">
                  <h3>Bem-vindo ao Portal MCMV</h3>
                  <p>Aqui você pode gerenciar suas inscrições no programa Minha Casa Minha Vida.</p>
                </div>
                
                {registration ? (
                  <>
                    <div className="dashboard-card">
                      <h3>Número da Inscrição</h3>
                      <p className="numero-inscricao-destaque">{registration.numero_inscricao}</p>
                      <small>Guarde este número para consultas futuras</small>
                    </div>
                    <div className="dashboard-card">
                      <h3>Status da Inscrição</h3>
                      <p>Status: {registration.status === 'inscricao_recebida' ? 'Inscrição recebida' : 
                                 registration.status === 'nao_contemplada' ? 'Não contemplada' : 
                                 registration.status === 'contemplada' ? 'Contemplada' : registration.status}</p>
                      <small>Última atualização: {new Date(registration.updated_at).toLocaleDateString('pt-BR')}</small>
                    </div>
                  </>
                ) : (
                  <div className="dashboard-card">
                    <h3>Status da Inscrição</h3>
                    <p>Você ainda não possui cadastro no programa MCMV.</p>
                    <p>Complete seu cadastro na aba "Ficha MCMV" para gerar seu número de inscrição.</p>
                  </div>
                )}
                
                <div className="dashboard-card">
                  <h3>Próximos Passos</h3>
                  <p>{registration ? 
                    'Mantenha seus dados atualizados e acompanhe o status da sua inscrição.' : 
                    'Complete seu cadastro e envie os documentos necessários.'}
                  </p>
                </div>
              </div>
            )}
          </div>
        );
      case 'cadastro':
        return (
          <div >
             <McmvRegistrationForm />
          </div>
        );
      case 'meus-cadastros':
        return (
          <div className="dashboard-section">
            <h1>Meus Cadastros</h1>
            <div className="cadastros-list">
              <div className="cadastro-item">
                <h3>Cadastro #001</h3>
                <p>Status: Em análise</p>
                <p>Data: 15/01/2024</p>
              </div>
            </div>
          </div>
        );
      case 'documentos':
        return (
          <div className="dashboard-section">
            <h1>Documentos</h1>
            <div className="documentos-section">
              <h3>Documentos Necessários</h3>
              <ul>
                <li>RG e CPF</li>
                <li>Comprovante de Renda</li>
                <li>Comprovante de Residência</li>
                <li>Certidão de Nascimento/Casamento</li>
              </ul>
            </div>
          </div>
        );
      case 'perfil':
        return (
          <div className="dashboard-section">
            <h1>Meu Perfil</h1>
            <div className="perfil-info">
              <h3>Informações Pessoais</h3>
              <p><strong>Nome:</strong> {user?.name}</p>
              <p><strong>Email:</strong> {user?.email}</p>
              <p><strong>Tipo:</strong> Inscrito</p>
            </div>
          </div>
        );
      default:
        return <div>Seção não encontrada</div>;
    }
  };

  return (
    <div className="user-dashboard">
      <Sidebar
        activeSection={activeSection}
        onSectionChange={(section) => {
          setActiveSection(section);
          if (section === 'cadastro') {
            setSidebarOpen(false);
          }
        }}
        userName={user?.name || 'Usuário'}
        onLogout={logout}
        collapsed={!sidebarOpen}
        onToggle={() => setSidebarOpen((prev) => !prev)}
      />
      <div className="dashboard-main" style={{ marginLeft: sidebarOpen ? 280 : 0 }}>
        {!sidebarOpen && (
          <button
            className="sidebar-fab"
            onClick={() => setSidebarOpen(true)}
            aria-label="Mostrar menu"
          >
            ☰ Menu
          </button>
        )}
        <div className="dashboard-content">
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default UserDashboard;